import { Component, HostBinding, Input, OnDestroy, OnInit, inject, input, signal } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'adm-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [MatProgressSpinner, MatIcon, AsyncPipe],
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  appState = inject(AppState);

  loading$ = input<BehaviorSubject<boolean>>();
  loadingSignal = input<boolean>();
  @Input() hasNoData: boolean;
  @Input() noResultsMessage: string;
  @Input() loadingMessage: string;
  @Input() loadingRow: boolean;

  loadingObsAsSignal = signal(false);
  subscription: Subscription;

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  ngOnInit(): void {
    if (this.loading$()) {
      this.subscription = this.loading$()!.subscribe(isLoading => {
        this.loadingObsAsSignal.set(isLoading);
      });
    }
  }

  @HostBinding('class')
  public get isLoadingRow(): string {
    return this.loadingRow ? 'loading-spinner loading-spinner--loading-row' : 'loading-spinner';
  }
}
